export const pathInventorySummary = "summary";
export const pathFeedbackLoop = "feedback-loop";
export const pathFeedbackRemo = "feedback-remo";
